<template>
  <div class="coverart">
    <animated-cover-art v-show="!showImage" />
    <div class="coverart__image-container" v-show="showImage">
      <div class="coverart__image">
        <img :src="showImage" />
        <!-- {{getDetailUrl}}-->
        <div class="showlist__episode-status" @click="togglePlay()">
            <div class="showlist__episode-icons">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" v-show="!playerStatus.playing" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" v-show="playerStatus.playing" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M192 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm256 0v352c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48z"/></svg>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AnimatedCoverArt from './AnimatedCoverArt.vue';
export default {
  props: [
      'streamUrl'
  ],
  components: { AnimatedCoverArt },
  computed: {
    isStreaming(){ return this.$store.state.player.current.url == this.streamUrl; },
    currentShow(){ return this.$store.state.player.show; },
    showImage() {
      if(!this.currentShow) return false
      return this.currentShow.fields.broadcast_image.sizes.medium_large
    },
    playerStatus(){ return this.$store.state.player.status; }
  },
  methods: {
      play(show) {
          this.$store.dispatch('player/setShow', show);
          this.$store.dispatch('player/startPlayer');
      },
      togglePlay() {
          if(this.isStreaming) return this.$store.dispatch('player/setShow', this.currentShow);
          
          this.$store.dispatch('player/toggleStartPlayer');
      },      
  },
};
</script>

<style lang="scss">
  .coverart {
    width: 100%;
    max-width: 360px;
    margin: 0 auto;    
    height: auto;

    @include media-breakpoint-down(lg){
      @at-root .sk-player__player & {
        width: 70%;
        margin: 15%;
      }
    }

    &__image-container {
      position: relative;
      width: 100%;
      padding-top: 100%;
    }

    &__image {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: .25rem;
      }
    }
  }

  .sk-player__mobile-container {
    .showlist__episode-icons {
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      border-radius: 50%;
      background: #ea6323;
      color: #fff;
      cursor: pointer;
      right: -12px;
      top: calc(50% - 12px);   
      padding: 0.5rem; 
    }  
  }

</style>